import { useQuery } from "react-query";
import { getTerritory } from "../../../../../actions/Utilities/Territory";

export default function useTerritoryOptions() {
  const { data } = useQuery("GetTerritoryOptions", getTerritory, {
    refetchOnWindowFocus: false,
  });
  return data;
}
